var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquashCourt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 300,
    viewBox: "0 0 202 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_6898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9473 90.0534L61.8309 92.0925L154.592 142.878L155.708 140.839L62.9473 90.0534Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8178 73.9585L64.6998 76.0007L165.657 131.273L166.775 129.231L65.8178 73.9585Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9656 59.6649L70.851 61.7009L177.37 120.018L178.484 117.982L71.9656 59.6649Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4076 46.0704L78.2895 48.1125L184.808 106.43L185.926 104.388L79.4076 46.0704Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.138 33.191L87.025 35.2239L192.255 92.8358L193.368 90.8029L88.138 33.191Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.149 22.0979L99.0306 24.1401L191.792 74.9252L192.91 72.8831L100.149 22.0979Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.681 10.7504L110.567 12.7864L194.479 58.7271L195.594 56.6911L111.681 10.7504Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 11.068L61.4879 99.4131L63.5241 100.527L111.872 12.1823L109.835 11.068Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.595 4.45426L63.2393 122.003L65.2753 123.117L129.631 5.56895L127.595 4.45426Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.252 5.30274L72.8024 130.328L74.8384 131.443L143.288 6.41742L141.252 5.30274Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.901 6.15145L79.7808 143.418L81.8201 144.534L156.94 7.26748L154.901 6.15145Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.784 12.1073L90.6642 149.374L92.7035 150.49L167.824 13.2233L165.784 12.1073Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.667 18.0728L101.523 155.326L103.559 156.441L178.703 19.1875L176.667 18.0728Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.749 29.1156L115.185 156.177L117.221 157.291L186.785 30.2303L184.749 29.1156Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.82 40.1448L131.995 151.242L134.035 152.359L194.859 41.2612L192.82 40.1448Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.828 58.6878L148.465 147.024L150.507 148.142L198.87 59.8058L196.828 58.6878Z",
    fill: "#9FA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 8.10128C104.735 -27.2589 48.1602 61.33 62.7636 118.504C64.877 126.781 70.4668 165.678 53.8839 194.56L74.4364 205.811C89.5611 177.28 124.245 160.345 133.657 157.203C189.555 138.535 234.13 43.5742 169.327 8.10128V8.10128ZM78.2969 185.561C77.4987 186.573 76.3676 187.27 75.1045 187.527C73.8414 187.785 72.5279 187.587 71.3972 186.968C70.2664 186.349 69.3915 185.349 68.9278 184.146C68.4641 182.943 68.4416 181.615 68.8642 180.397C71.5904 172.233 73.5101 162.86 73.4009 147.313C73.3967 146.788 73.5486 146.274 73.8372 145.836C74.1258 145.398 74.5381 145.056 75.0218 144.853C75.5054 144.65 76.0384 144.595 76.5532 144.695C77.068 144.796 77.5413 145.047 77.9129 145.418C84.8632 152.101 93.4725 156.807 102.851 159.049C103.37 159.16 103.843 159.424 104.211 159.807C104.579 160.189 104.825 160.673 104.916 161.196C105.008 161.718 104.941 162.257 104.725 162.741C104.509 163.226 104.153 163.635 103.703 163.917C94.4642 169.739 85.4119 176.741 78.2969 185.561ZM136.386 147.873C121.307 153.804 106.095 153.29 93.5871 146.439C81.0795 139.588 72.4534 127.066 69.3115 111.153C62.7882 78.0045 86.3206 25.6211 121.089 11.923C135.58 6.21686 150.43 7.43557 165.234 15.5403C180.038 23.6451 189.104 35.4835 192.084 50.6892C199.256 87.2153 167.988 135.435 136.379 147.873H136.386Z",
    fill: "#E33326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3285 222.217C68.9241 223.091 71.1396 222.112 72.2844 220.023L76.7048 211.954C77.846 209.865 77.4797 207.466 75.8806 206.593L52.4468 193.764C50.8513 192.887 48.6287 193.87 47.4839 195.959L43.067 204.028C41.9223 206.117 42.2991 208.512 43.8947 209.389L44.8246 209.897L10.9719 271.734L10.0456 271.216C8.44647 270.342 6.22038 271.329 5.08269 273.414L0.662218 281.49C-0.479002 283.579 -0.109163 285.978 1.48995 286.851L24.9237 299.68C26.5193 300.557 28.7383 299.574 29.8831 297.485L34.3 289.412C35.4413 287.33 35.0749 284.928 33.4793 284.051L32.5459 283.544L66.3986 221.707L67.3285 222.217Z",
    fill: "#262628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8953 240.833L24.9843 246.15L46.5556 257.96L49.4666 252.643L27.8953 240.833Z",
    fill: "#D0CC29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6654 252.204L18.7543 257.521L40.3256 269.331L43.2367 264.014L21.6654 252.204Z",
    fill: "#D0CC29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_6898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201.38,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquashCourt);
export default __webpack_public_path__ + "static/media/SquashCourt.5879e8ecfeb1527de287dcef1434bf2b.svg";
export { ForwardRef as ReactComponent };